var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem13B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m118.5 43.2h-33.7c0.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2s5 17.2 7.1 28.5c2 11.4 3.1 24.7 3.2 39.8-0.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.7c0.1 0 1.2-1.9 3.2-5.8 2.1-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5-17.2 7.1-28.6 2-11.4 3.1-24.7 3.2-39.8-0.1-15.1-1.2-28.4-3.2-39.8-2.1-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5-13.4-7.1-17.2s-3.1-5.7-3.2-5.7z",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.4 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-0.2-0.2h-35.5l0.7 1.1c0-0.1 0.1 0.1 0.4 0.4 0.6 0.9 2 3.4 4.1 7.7s4.3 10.2 6.8 17.8c2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-0.1 15.1-1.2 28.4-3.2 39.7-2 11.4-4.3 20.8-7 28.4-1.3 3.8-2.6 7.2-3.8 10s-2.4 5.2-3.3 7.1c-1 1.9-1.8 3.4-2.4 4.4-0.2 0.4-0.4 0.7-0.5 1.1l-0.4 0.2-0.7 1.3h35.5l0.2-0.4c0.1-0.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-0.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.4-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-0.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-0.3 0.4-0.5 0.7-0.7 1.1h-32c1-1.5 2.5-4.5 4.6-9s4.4-10.6 6.7-18.2c2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-0.1-13.4-0.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c0.7 0.9 2.1 3.5 4.2 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.9 43.2h-33.5c0.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2 2.7 7.7 5 17.2 7.1 28.5 2 11.4 3.1 24.7 3.2 39.8-0.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.5c0.1 0 1.2-1.9 3.3-5.8 2-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5.1-17.2 7.1-28.6 2.1-11.4 3.2-24.7 3.3-39.8-0.1-15.1-1.2-28.4-3.3-39.8-2-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5.1-13.4-7.1-17.2-2.1-3.8-3.2-5.7-3.3-5.7z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-0.2-0.2h-35.5l0.7 1.1c0.1-0.1 0.1 0.1 0.2 0.4 0.7 0.9 2.1 3.4 4.2 7.7s4.4 10.2 6.9 17.8c2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-0.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10s-2.3 5.2-3.2 7.1c-1 1.9-1.8 3.4-2.4 4.4-0.3 0.4-0.5 0.7-0.7 1.1-0.1 0.1-0.1 0.2-0.2 0.2l-0.7 1.3h35.5l0.2-0.4c0.1-0.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-0.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.3-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6s2.9 23.4 2.9 37.5c-0.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-0.3 0.4-0.5 0.7-0.7 1.1h-32c1-1.5 2.5-4.5 4.6-9s4.4-10.6 6.7-18.2c2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-0.1-13.4-0.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c0.6 0.9 1.9 3.5 4.1 7.7z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 113.757,
    y: 107.299,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "B"), /*#__PURE__*/React.createElement("text", {
    x: 113.757,
    y: 124.799,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 113.757,
    y: 142.149,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 114.212,
    y: 159.74899,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 114.212,
    y: 177.19901,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 152.10001,
    y: 117.449,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    x: 148.457,
    y: 134.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 148.00101,
    y: 152.44901,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    x: 148.457,
    y: 169.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "N"), /*#__PURE__*/React.createElement("path", {
    d: "m377.6 43.2h-33.7c-0.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8 0.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-0.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8 0.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.4 43.6 0.7-1.1h-35.5l-0.2 0.2c-0.1 0.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9 0.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7s5.1 13.4 7.1 17.3c2.1 3.9 3.2 5.9 3.3 5.9l0.2 0.4h35.5l-0.7-1.3c-0.1 0-0.2-0.1-0.4-0.2-0.6-0.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5 0.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5s5-13.3 7.1-17.1c1-1.8 1.8-3.2 2.4-4.2 0.2-0.5 0.4-0.9 0.5-1.1 0.2-0.3 0.3-0.5 0.4-0.4m-6.7 9.6c-2.1 4.6-4.3 10.6-6.7 18.2-2.4 7.5-4.4 16.5-6 27.1-1.7 10.6-2.6 22.6-2.6 36 0.1 13.6 0.9 25.7 2.6 36.3s3.7 19.6 6.1 27.2 4.6 13.7 6.7 18.2c2.1 4.6 3.7 7.6 4.6 9h-32.2c-0.6-0.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5 0.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5c2.8-7.6 5.2-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2 0.2-0.5 0.4-0.9 0.5-1.1h32.1c-0.9 1.5-2.5 4.6-4.6 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.3 43.2h-33.7c-0.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8 0.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-0.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8 0.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.9 43.6 0.9-1.1h-35.5l-0.2 0.2c-0.1 0.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9 0.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7s5.1 13.4 7.1 17.3c2.1 3.9 3.2 5.9 3.3 5.9l0.2 0.4h35.5l-0.9-1.3c0.1 0 0-0.1-0.2-0.2-0.6-0.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5 0.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5s5-13.3 7.1-17.1c1-1.8 1.8-3.2 2.4-4.2 0.2-0.5 0.4-0.9 0.5-1.1l0.2-0.4m-6.6 9.6c-2.1 4.6-4.3 10.6-6.6 18.2-2.3 7.5-4.3 16.5-6 27.1-1.6 10.6-2.5 22.6-2.6 36 0.1 13.6 0.9 25.7 2.6 36.3s3.7 19.6 6 27.2c2.4 7.6 4.6 13.7 6.7 18.2 2.1 4.6 3.7 7.6 4.6 9h-32c-0.6-0.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5 0.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5 5-13.3 7.1-17.1c1-1.8 1.8-3.2 2.4-4.2 0.2-0.5 0.4-0.9 0.5-1.1h32c-1 1.5-2.6 4.6-4.7 9.2z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 336.10602,
    y: 107.299,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "B"), /*#__PURE__*/React.createElement("text", {
    x: 336.10602,
    y: 124.799,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 336.10602,
    y: 142.149,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 336.56299,
    y: 159.74899,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 336.56299,
    y: 177.19901,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 374.54999,
    y: 117.449,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    x: 370.90601,
    y: 134.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 370.45099,
    y: 152.44901,
    cursor: "move",
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    x: 370.90601,
    y: 169.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "N"), /*#__PURE__*/React.createElement("path", {
    d: "m629 43.2h-33.5v182.7h33.5v-182.7z",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629.7 48.9v-6.4h-35v184.2h35v-177.8m-1.4-4.9v181.3h-32.1v-181.2h32.1v-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.7 43.2h-33.7v182.7h33.7v-182.7z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m663.5 48.9v-6.4h-35.2v184.2h35.2v-177.8m-1.5-4.9v181.3h-32.2v-181.2h32.2v-0.1z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 606.40601,
    y: 107.299,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "B"), /*#__PURE__*/React.createElement("text", {
    x: 606.40601,
    y: 124.799,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 606.40601,
    y: 142.149,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 606.862,
    y: 159.74899,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 606.862,
    y: 177.19901,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 644.95099,
    y: 117.449,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    x: 641.30701,
    y: 134.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 640.85199,
    y: 152.44901,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    x: 641.30701,
    y: 169.85001,
    fill: "#fff",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "16.397px"
  }, "N"), /*#__PURE__*/React.createElement("path", {
    d: "m133 246.1c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6 6.2-1.2 8.6-3.6 3.6-5.3 3.6-8.7-1.2-6.3-3.6-8.7z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 120.47 259.67)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "1"), /*#__PURE__*/React.createElement("path", {
    d: "m382.7 246.1c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6 6.2-1.2 8.6-3.6 3.6-5.3 3.6-8.7-1.2-6.3-3.6-8.7z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 370.17 259.67)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "2"), /*#__PURE__*/React.createElement("path", {
    d: "m640.3 246.1c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6 6.2-1.2 8.6-3.6 3.6-5.3 3.6-8.7-1.2-6.3-3.6-8.7z",
    fill: "#369",
    fillOpacity: 0.502
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 627.77 259.67)",
    fill: "#fff",
    fontFamily: "'ArialMT'",
    fontSize: "11.482px"
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem13B);
export default __webpack_public_path__ + "static/media/item13b.63e62ac4824104fcbabb4da807a3d84f.svg";
export { ForwardRef as ReactComponent };